var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("apps-integration", {
    attrs: {
      app: _vm.app,
      "qr-code-url": _vm.qrCodeUrl,
      account: _vm.accountId,
      env: _vm.env,
      "is-initializing": _vm.isInitializing,
      "is-updating": _vm.isUpdating,
      "is-activating": _vm.isActivating,
    },
    on: {
      create: function ($event) {
        return _vm.createOneReachApp({ app: $event })
      },
      update: function ($event) {
        return _vm.updateOneReachApp({ app: $event })
      },
      "qr-code-click": _vm.openQRCodeURL,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }